module.exports = __webpack_public_path__ + "assets/68cbcd18ac6666f31fcdcb01a4350028.png";